// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SKBN","top":"styles_top__hlGvd","left":"styles_left__3F-tm","description":"styles_description__3T6hM"};